 // src/components/Layout/BareLayout.js
const BareLayout = ({ children }) => <>{children}</>;
export default BareLayout;
